export const getMetricDescription = (value: number, type: "precision" | "recall" | "f1") => {
  if (type === "precision") {
    if (value === 1.0) return "All retrieved results are relevant";
    if (value >= 0.8) return "Most results are relevant";
    if (value >= 0.6) return "Some noise in results";
    return "Many irrelevant results";
  }
  if (type === "recall") {
    if (value === 1.0) return "Found every relevant result";
    if (value >= 0.75) return "Found most relevant results";
    if (value >= 0.5) return "Found half of what's relevant";
    return "Missed most relevant results";
  }
  if (type === "f1") {
    if (value >= 0.9) return "Excellent overall accuracy";
    if (value >= 0.7) return "Good but can improve";
    if (value >= 0.5) return "Fair - needs tuning";
    return "Poor - major improvements needed";
  }
  return "";
};



export const getMetricDots = (value: number) => {
  const filled = Math.round(value * 4);
  return Array.from({ length: 4 }, (_, i) => i < filled);
};
